module.exports = __webpack_public_path__ + "img/idcard-front-example.bf15005f.png";